import { CLASS_ACTIVE } from "../tools/constants/classes";
import { Section } from '../tools/section';
import { Slider } from '../objects/slider';
import { Autoplay, EffectFade } from 'swiper/modules';

const SELECTOR_TOP_BAR = "[data-top-bar]";
const SELECTOR_TOP_BAR_CAROUSEL = '[data-carousel]';

class CarouselSection extends Section {
  private topBarCarouselElement:HTMLElement | null = null;
  private slider: Slider | null = null;

  queryChildren(container:HTMLElement) {
    this.topBarCarouselElement = container.querySelector(SELECTOR_TOP_BAR_CAROUSEL);
  }

  attachEvents() {
    this.initTopbarCarousel();
  }

  detatchEvents() {
  }

  initTopbarCarousel() {
    if (this.topBarCarouselElement) {
      const speed = this.topBarCarouselElement.getAttribute('data-autoplay-speed');
      const autoplayEnabled = this.topBarCarouselElement.getAttribute('data-autoplay') !== 'false';

      this.slider = new Slider(this.container, {
        modules: [EffectFade, Autoplay],
        spaceBetween: 0,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        loop: true,
        autoplay: autoplayEnabled ? {
          delay: speed ? parseInt(speed, 10) : 5000,
          disableOnInteraction: true,
        } : false,
        slidesPerView: 1,
        direction: 'horizontal',
      }, SELECTOR_TOP_BAR_CAROUSEL);
    }
  }
}

Section.register(SELECTOR_TOP_BAR, CarouselSection);